import { Link } from "react-router-dom";
import { stories } from "@/mocks/stories";
import { stats } from "@/mocks/site";

export default function HeroSection() {
  const featured = stories[0];

  return (
    <section className="relative overflow-hidden border-b border-background-200 bg-background-50">
      <div className="paper-grain absolute inset-0" aria-hidden="true"></div>
      <div
        className="absolute -right-32 -top-24 h-80 w-80 rounded-full bg-accent-100/70 blur-3xl"
        aria-hidden="true"
      ></div>

      <div className="relative mx-auto grid max-w-content grid-cols-1 gap-10 px-4 py-14 md:px-6 lg:grid-cols-12 lg:gap-12 lg:py-20">
        <div className="lg:col-span-7">
          <p className="inline-flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-1.5 text-xs font-label tracking-[0.15em] text-foreground-700">
            <i className="ri-radar-line text-primary-600" aria-hidden="true"></i>
            暗线 · 匿名爆料聚合站
          </p>

          <h1 className="mt-5 font-heading text-3xl font-black leading-[1.25] tracking-tight text-foreground-950 md:text-5xl">
            把被遮盖的部分，
            <br className="hidden md:block" />
            一页一页<span className="relative text-primary-700">翻出来</span>。
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600">
            知情人、线人、内部人私下透露的那些事，我们把它写成能被查证的稿件。不急着定性，先把线索摆上桌面，也把回应的位置留出来。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/stories"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-600 px-6 py-3 text-sm font-label font-medium text-background-50 transition-colors hover:bg-primary-700 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-stack-line text-base" aria-hidden="true"></i>
              浏览爆料库
            </Link>
            <Link
              to="/submit"
              className="inline-flex items-center justify-center gap-2 rounded-md border border-primary-300 bg-background-50 px-6 py-3 text-sm font-label font-medium text-primary-700 transition-colors hover:bg-primary-50 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-lock-line text-base" aria-hidden="true"></i>
              匿名投稿
            </Link>
          </div>

          <dl className="mt-10 grid grid-cols-2 gap-x-6 gap-y-5 border-t border-background-200 pt-7 sm:grid-cols-4">
            {stats.map((s) => (
              <div key={s.label}>
                <dt className="text-xs font-label text-foreground-500">{s.label}</dt>
                <dd className="mt-1.5 flex items-baseline gap-1">
                  <span className="font-heading text-2xl font-bold text-foreground-950">{s.value}</span>
                  <span className="text-xs font-label text-foreground-500">{s.unit}</span>
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="lg:col-span-5">
          <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <div className="relative h-52 overflow-hidden bg-background-200 md:h-64">
              <img
                src={featured.cover}
                alt={`${featured.title} 配图`}
                title={`${featured.title} - ${featured.category}`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-4 top-4 flex items-center gap-1 rounded-md bg-primary-600 px-3 py-1.5 text-xs font-label font-medium text-background-50">
                <i className="ri-bookmark-3-line" aria-hidden="true"></i>
                本期头条
              </span>
            </div>
            <div className="p-5">
              <div className="flex flex-wrap items-center gap-3 text-xs font-label text-foreground-500">
                <span className="text-primary-600">{featured.category}</span>
                <span className="h-1 w-1 rounded-full bg-background-400" aria-hidden="true"></span>
                <span>{featured.date}</span>
                <span className="h-1 w-1 rounded-full bg-background-400" aria-hidden="true"></span>
                <span className="flex items-center gap-1">
                  <i className="ri-user-voice-line" aria-hidden="true"></i>
                  {featured.source}
                </span>
              </div>
              <h2 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950">
                <Link to={`/story/${featured.id}`} className="transition-colors hover:text-primary-700 cursor-pointer">
                  {featured.title}
                </Link>
              </h2>
              <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-foreground-600">{featured.excerpt}</p>
              <Link
                to={`/story/${featured.id}`}
                className="mt-4 inline-flex items-center gap-1.5 text-sm font-label font-medium text-primary-700 transition-colors hover:text-primary-800 cursor-pointer"
              >
                阅读全文
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}